<div class="odin-mfa-expired-dialog">
  <h2 mat-dialog-title>{{ isConfirmingCancel ? 'Confirm cancellation' : 'Confirm identity' }}</h2>
  <mat-dialog-content>
    @if (isConfirmingCancel) {
      <p>
        Do you want to continue without completing multi-factor authentication?
      </p>

      <p class="hint">
        Elevated features will remain unavailable until MFA is completed.
      </p>
    }
    @else {

      @if (errorMessageOtp) {
          <p>
            Multiple MFA codes have already been sent.
            Please wait before requesting another code.
          </p>
          <p class="error-message">
            {{ errorMessageOtp }}
          </p>
          <button 
            mat-raised-button 
            color="primary"
            type="button"
            [disabled]="retryInSeconds > 0"
            (click)="onRetryMfa()"
            class="retry-btn"
          >
            {{ retryInSeconds > 0 ? 'Retry in ' + retryInSeconds + 's' : 'Resend Code' }}
          </button>
      }
      @else {
        @if (data.deliveryMethod) {

          @if (data.deliveryMethod === 'App') {
            <!-- TOTP: show code input immediately, no send button -->
            <p>Please enter the MFA code from your authenticator app.</p>

            <mat-form-field
              appearance="outline"
              class="mfa-input"
            >
              <mat-label>6-digit MFA code</mat-label>
              <input
                matInput
                cdkFocusInitial
                maxlength="6"
                inputmode="numeric"
                pattern="[0-9]*"
                autocomplete="one-time-code"
                [(ngModel)]="mfaCode"
                (ngModelChange)="onMfaChange($event)"
              />
            </mat-form-field>
          }
          @else if (!codeSent) {
            <!-- Email/SMS: prompt to send code -->
            <p>
              Your MFA is set to <strong>{{ data.deliveryMethod }}</strong>.
              Click the button below to receive a verification code.
            </p>

            <button
              mat-raised-button
              color="primary"
              type="button"
              [disabled]="isSendingCode"
              (click)="onSendCode()"
              class="send-code-btn"
             data-test="auth-elevated-mfa-expired-send-code-button">
              @if (isSendingCode) {
                Sending...
              } @else {
                Send Code
              }
            </button>
          }
          @else {
            <!-- Email/SMS: code has been sent -->
            <p>
              A 6-digit MFA code has been sent via <strong>{{ data.deliveryMethod }}</strong>
              @if (data.sendTo) {
                <span> to <strong>{{ data.sendTo }}</strong></span>
              }.
              Please enter the code below to continue.
            </p>

            <mat-form-field
              appearance="outline"
              class="mfa-input"
            >
              <mat-label>6-digit MFA code</mat-label>
              <input
                matInput
                cdkFocusInitial
                maxlength="6"
                inputmode="numeric"
                pattern="[0-9]*"
                autocomplete="one-time-code"
                [(ngModel)]="mfaCode"
                (ngModelChange)="onMfaChange($event)"
              />
            </mat-form-field>

            <button
              mat-button
              color="primary"
              type="button"
              [disabled]="retryInSeconds > 0"
              (click)="onResendCode()"
              class="resend-btn"
            >
              {{ retryInSeconds > 0 ? 'Resend in ' + retryInSeconds + 's' : 'Resend Code' }}
            </button>
          }

          @if(errorMessage) {
            <p class="error-message">
              {{ errorMessage }}
            </p>
          }

        }
        @else {
          <p><strong>Loading MFA settings...</strong></p>
        }
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (isConfirmingCancel) {
      <button
        mat-button
        (click)="isConfirmingCancel = false"
      >
        Back
      </button>

      <button
        mat-raised-button
        color="warn"
        (click)="onConfirmationCancel()"
       data-test="auth-elevated-mfa-expired-confirmation-cancel-button">
        Confirm
      </button>
    }
    @else {
      <button
        mat-button
        color="warn"
        (click)="onCancel()"
       data-test="auth-elevated-mfa-expired-cancel-button">
        Cancel
      </button>

      <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="!isCodeValid() || isSubmitting"
        class="submit-btn"
       data-test="auth-elevated-mfa-expired-submit-button">
        @if (isSubmitting) {
          <odin-loading-spinner [diameter]="35" [active]="true"></odin-loading-spinner>
        } @else {
          Submit
        }
      </button>
    }
  </mat-dialog-actions>
</div>